<template>
    <div class="context">
        <div class="header">
            <el-page-header @back="back" content="选择问候语">
            </el-page-header>
        </div>
        <div class="select_box">
            <div class="left_box">
                <div class="top_btn">
                    <div class="title">已选问候语</div>
                    <div v-if="!look_disabled">
                        <el-button plain type="primary"
                                   @click="submit_select"
                                   size="small">选择完成</el-button>
                    </div>
                </div>
                <div class="table_box">
                    <el-table :data="select_list"
                              stripe
                              row-key="survey_id"
                              width="100%"
                              height="100%">
                        <el-table-column type="index" label="序号" width="60"></el-table-column>
                        <el-table-column v-for="(item, index) in columnData"
                                         :prop="item.prop"
                                         :label="item.label"
                                         :width="item.width"
                                         :formatter="item.formatter"
                                         :fixed="item.fixed"
                                         show-overflow-tooltip
                                         :key="index"></el-table-column>
                        <el-table-column label="操作" width="60" align="center" v-if="!look_disabled">
                            <template slot-scope="scope">
                                <span class="table_del_btn"
                                      @click="del_item(scope.row)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="line"></div>
            <div class="right_box" id="right_box" v-if="!look_disabled">
                <div class="search_box" id="search_box">
                    <el-form :model="searchForm" size="small">
                        <el-form-item label="标题">
                            <el-input v-model="searchForm.input"
                                      placeholder="请输入标题"
                                      @change="getTableData"
                                      class="width_200"></el-input>
                            <el-button style="margin-left: 15px"
                                       @click="getTableData"
                                       type="primary">搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table_box">
                    <el-card shadow="never"
                             v-for="(item, index) in tableData"
                             :key="index"
                             class="card_item">
                        <div class="select_icon"
                             @click="select_item(item)"
                             :class="showSelectIcon(item)">
                            <i class="el-icon-check"></i>
                        </div>

                        <div class="title">{{item.title}}</div>
                        <div class="text">{{item.abstract}}</div>
                        <div class="text">{{item.content}}</div>
                        <div class="text">{{item.remark}}</div>
                        <div class="date">
                            {{item.update_time}}
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import Sortable from "sortablejs";
export default {
    name: "greetingsView",
    data() {
        return {
            searchForm: {
                input: ''
            },

            select_list: [],
            columnData: [
                {label: '标题', prop: 'title'},
                // {label: '摘要', prop: 'abstract'},
                // {label: '内容', prop: 'content'},
                // {label: '备注', prop: 'remark'},
            ],
            tableData: [],
        }
    },
    props: [
        'push_config_id',
        'cycle_id',
        'look_type'
    ],
    computed: {
        ...mapState('manageData', [
            'base_content_type',
            'now_content_type',
        ]),
        look_disabled() {
            return this.look_type === 'look'
        }
    },
    mounted() {
        this.getSelectList();
        this.rowDrop();
    },
     methods: {
         rowDrop() {
             const tbody = document.querySelector('.el-table__body-wrapper tbody');
             const _this = this;
             //  指定父元素下可被拖拽的子元素
             Sortable.create(tbody, {
                 //  指定父元素下可被拖拽的子元素
                 draggable: ".el-table__row",
                 onEnd ({ newIndex, oldIndex }) {
                     const currRow = _this.select_list.splice(oldIndex, 1)[0];
                     _this.select_list.splice(newIndex, 0, currRow);
                 }
             });
         },
         back() {
             let params = null;
             this.$emit('changeSomeCode', params)
         },
         submit_select() {
             let ids = [];
             this.select_list.forEach(v => {
                 ids.push(v.wording_id)
             });
             let params = {
                 push_config_id: this.push_config_id,
                 cycle_id: this.cycle_id,
                 content_ids: ids
             };
             this.$emit('changeSomeCode', params)
         },
         select_item(item) {
             let has = false;
             this.select_list.map(v => {
                 if (v.wording_id == item.wording_id) {
                     has = true
                 }
             });
             if (has) {
                 this.del_item(item)
             } else {
                 this.select_list.push(item)
             }
         },
         del_item(item) {
             let index_ = -1;
             this.select_list.forEach((v, i) => {
                 if (item.wording_id == v.wording_id) {
                     index_ = i
                 }
             });
             this.select_list.splice(index_, 1)
         },

         showSelectIcon(item) {
             let class_name = '';
             this.select_list.map(v => {
                 if (v.wording_id == item.wording_id) {
                     class_name = 'selected_icon'
                 }
             });
             return class_name
         },

         getTableData() {
             let params = {
                 title: this.searchForm.input,
                 wtype: 'GREETING'
             };
             this.httpGet('/wording/list', params).then(res => {
                 this.tableData = res.data;
             });
         },
         getSelectList() {
             let params = {
                 push_config_id: this.push_config_id,
                 cycle_id: this.cycle_id,
             };
             this.httpGet('/push/content/detail', params).then(res => {
                 if (this.base_content_type &&
                     (!this.now_content_type ||this.base_content_type === this.now_content_type)) {
                     // 上次（存在）和当前推送内容类型一致
                     this.select_list = res.data;
                 } else {
                     this.select_list = [];
                 }
                 if (this.look_disabled) {
                     // 查看状态 显示数据
                     this.select_list = res.data;
                 }
                 this.getTableData();
             })
         },
    }
}
</script>

<style scoped lang="scss">
.context {
    width: 100%;
    height: 100%;
    .header {
        height: 45px;
    }
    .select_box {
        width: 100%;
        height: calc(100% - 50px);
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        .left_box {
            flex: 1;
            height: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            .top_btn {
                height: 45px;
                display: flex;
                justify-content: space-between;
                .title {
                    line-height: 30px;
                    font-size: 16px;
                    padding: 0 10px;
                }
            }
            .table_box {
                width: 100%;
                overflow-y: auto;
                display: flex;
                flex-wrap: wrap;
                height: calc(100% - 45px);
                align-content: flex-start;
            }
        }
        .line {
            width: 1px;
            height: 100%;
            background: #ccc;
        }
        .right_box {
            flex: 2;
            height: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            .search_box {
                height: 45px;
                .input_box {
                    display: flex;
                    flex-flow: wrap;
                    .btn {
                        height: 25px;
                        line-height: 25px;
                        font-size: .875rem;
                        padding: 0 10px;
                        box-sizing: border-box;
                        margin: 7px 10px;
                        cursor: pointer;
                        color: #606266;
                    }
                    .actived_btn {
                        box-sizing: border-box;
                        border: 1px solid #38adff;
                        border-radius: 3px;
                    }
                }
                .check_box {
                    display: flex;
                    .all_check {
                        flex: 0 0 80px;
                    }
                    .check_btn {
                        flex: 1;
                    }
                }
            }
            .table_box {
                width: 100%;
                height: calc(100% - 45px);
                overflow-y: auto;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
            }
        }
        .table_box {
            .card_item {
                width: 320px;
                height: 250px;
                position: relative;
                z-index: 1;
                margin: 0 5px 5px 0;
                line-height: 30px;
                .title {
                    padding: 0 10px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .text {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                    height: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .date {
                    font-size: 0.875rem;
                    color: #8d8d8d;
                    padding: 0 10px;
                }

                .select_icon {
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 65px;
                    cursor: pointer;
                    /*border: 1px solid #409EFF;*/
                    /*color: #409EFF;*/
                    background: #909399;
                    color: #fff;
                    opacity: .7;
                    i {
                        font-size: 2rem;
                    }
                }
                .selected_icon {
                    background: #409EFF;
                    color: #fff;
                }
            }
        }
    }
}
</style>